export const logoLanguage = window.location.host.includes('notaris') ? 'nl' : 'fr';
